import {
  Button as MantineButton,
  ButtonProps as MantineButtonProps
} from '@mantine/core'
import clsx from 'clsx'
import { checkText, type CheckTProps } from '../../utils/checkText'

export type ButtonProps = MantineButtonProps &
  CheckTProps & {
    active?: boolean
    className?: string
    onClick?: () => void | Promise<void | Boolean>
    type?: 'button' | 'submit' | 'reset'
  }

export const Button = ({
  active,
  children,
  t,
  td,
  ns,
  tdata,
  className,
  variant,
  ...props
}: ButtonProps) => (
  <MantineButton
    {...props}
    variant={variant}
    className={clsx(
      className,
      active &&
        variant === 'nav' &&
        'interactive-nav-active font-medium',
      active &&
        (variant === 'transparent' ||
          variant === 'subtle' ||
          variant === 'light') &&
        'bg-shade-medium! text-shell-foreground! font-medium shadow-none hover:bg-shade!'
    )}
  >
    {checkText({
      children,
      t,
      ns,
      tdata: tdata ?? td
    } as Parameters<typeof checkText>[0])}
  </MantineButton>
)
